import React, { useEffect } from 'react'
import {
  Title,
  GRID_VARIANT_VERTICAL_BIG,
  Grid,
  GridCell,
  Flex,
  FlexItem,
  Text,
  SpacingVertical,
  SPACING_8,
  Button,
  SKELETON_LOADER_VARIANT_ONWHITE,
  SkeletonLoader
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import iconRecipients from 'Img/icon-total-recipients.svg'

import ReactTooltip from 'react-tooltip'
import styled from '@emotion/styled'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import { pageState, wizardEnableStep1State } from '../recoil/states/page'
import { recipientsState } from '../recoil/states/state'
import { countFilterRecipientsCallback } from '../recoil/callbacks/callbacks'

const IconStyled = styled.img`
  position: relative;
  top: -15px;
  left: -15px;
`

const RecipientsSummary = () => {
  const intl = useIntl()
  const wizardEnableStep1 = useRecoilValue(wizardEnableStep1State)
  const {
    totalRecipients,
    filetrRecipients,
    loadingRecipients
  } = useRecoilValue(recipientsState)
  const { recipients } = useRecoilValue(pageState)
  const countFilterRecipients = useRecoilCallback(
    countFilterRecipientsCallback,
    []
  )

  useEffect(() => {
    ReactTooltip.rebuild()
  }, [])

  return (
    <>
      <Grid cols={12}>
        <GridCell span={8}>
          <Flex padding='0'>
            <FlexItem padding='0'>
              <IconStyled src={iconRecipients} />
            </FlexItem>
            <Flex flexDirection='column'>
              <Title>
                {loadingRecipients ? (
                  <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
                ) : (
                  intl.formatMessage(
                    {
                      id: 'Load.Rcs.RecipientsSelectionTotalSelected'
                    },
                    {
                      x:
                        recipients === 'filter'
                          ? filetrRecipients === null
                            ? '-'
                            : intl.formatNumber(filetrRecipients)
                          : totalRecipients === null
                          ? '-'
                          : intl.formatNumber(totalRecipients)
                    }
                  )
                )}
              </Title>
              <SpacingVertical variant={SPACING_8} />
              <Text variant='light'>
                {totalRecipients === null ? (
                  <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
                ) : (
                  intl.formatMessage(
                    {
                      id: 'Load.Rcs.RecipientsSelectionTotalSelectable'
                    },
                    {
                      y: intl.formatNumber(totalRecipients)
                    }
                  )
                )}
              </Text>
            </Flex>
          </Flex>
        </GridCell>
        {recipients === 'filter' && (
          <GridCell span={4}>
            <Button
              kind='secondary'
              disabled={!wizardEnableStep1}
              onClick={countFilterRecipients}
              data-mu-test='button-UpdateRecipients'
            >
              {intl.formatMessage({
                id: 'Load.Rcs.RecipientsSelectionRefresh'
              })}
            </Button>
          </GridCell>
        )}
      </Grid>
    </>
  )
}

export default RecipientsSummary
